import React, { Component, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DKLabel, DKButton, DKSpinner, DKInput, INPUT_TYPE, INPUT_VIEW_DIRECTION, showLoader, removeLoader, DKListPicker, DKCalendar, TOAST_TYPE, showToast } from "deskera-ui-library";
import { TableManger, TABLES } from "../../managers/TableManger";
import BooksIntegrationService from "../../services/BooksIntegrationService";
import { parseColumnConfig, parseJEColumnConfig, parseVisibleColumnConfig, SyncRevertJEBooksIntegrationColumnConfig } from "../configs/config";
import Utility, { deepClone } from "../../utility/Utility";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { selectPayrunsData, addColumnToSyncRevertJEColumnConfig, fetchSyncRevertJEData } from "../../Redux/Slices/SyncJEToBooksSlice.js"
import RouteManager from "../../managers/RouteManager";

const SyncJEToBooksTable = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    //State hooks

    const [unSyncedJEList, setUnSyncedJEList] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);

    //Store data selectors
    const dispatch = useDispatch();
    const payrunsData = useSelector(selectPayrunsData);
    const [isSync, setSync] = useState(props.isSync)
    const columnConfig = useSelector(addColumnToSyncRevertJEColumnConfig);
    const isActionEnabled = false;
    const [selectedRow, setSelectedRow] = useState([]);
    const [gridWidth, setGridWidth] = useState(950);
    const gridContainer = useRef()

    useEffect(() => {
        // RouteManager.setPresenter({ props });
        if (props && props.filter) {

            showLoader();
            /* API Calls Start */
            loadPayruns(props.filter);
            
            /* API Calls End */
            return () => {
                window.openSelectedLocation = () => { };
                setUnSyncedJEList(initialState)
            };
        }
        

    }, [props.generate])

    useEffect(() => {
        if (!Utility.isEmpty(payrunsData) && props.filter) {
            setGridWidth(gridContainer?.current?.clientWidth || 1000)
            const { payruns, pageable, totalPages, totalElements } = payrunsData;
            const rowData = SyncRevertJEBooksIntegrationColumnConfig(payruns);
            let columns = parseJEColumnConfig(TableManger.getTableColumns(TABLES.SYNC_JE_TO_BOOKS),isSync);
            let reportColumn = parseVisibleColumnConfig(columns)
            const passingData = {
                columnData: deepClone(reportColumn),
                rowData,
                filter: [],
                originalData: rowData
            };
            
            setUnSyncedJEList(passingData);
            setTotalPageCount(1);
            setCurrentPage(1);
            setTotalCount(payruns ? payruns.length : 0)
        }
    }, [payrunsData, props]);

    const loadPayruns = async (config) => {
        try {
            
            BooksIntegrationService.apiConfig = config;
            await dispatch(fetchSyncRevertJEData());
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };
    const onDeleteContact = (data) => {
        const row = data && data.rowData ? data.rowData : {};
        console.log(row)
    };

    const onRowEdit = (data) => {

    };
    const onSearch = (searchTerm) => {
        const config = {
            ...BooksIntegrationService.apiConfig,
            Page: 0,
            SearchTerm: searchTerm
        };
        loadPayruns(config);
    };
    const newColumnAdded = (data) => {
        const columns = unSyncedJEList.columnData;
        columns.push(data);
        setUnSyncedJEList({ ...unSyncedJEList, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {

    };

    const onRowAdd = (newRow) => {

    };
    const onSelection = (data) => {
        
                            if(props.selectedData) {
                                props.selectedData(data)
                            }
                            // setSelectedRow(data)
    }
    return (
        <>
            <div className="column parent-height mt-l pl-l" style={{
                    width: '98%'
            }}>
                <div className="column parent-width mb-s position-relative flex-1 parent-width" ref={gridContainer}>
                    <DataGridHolderPayroll
                        tableName={TABLES.SYNC_JE_TO_BOOKS}
                        displayTableName={""}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        onRowDelete={onDeleteContact}
                        onSelection={(data)=>{
                            onSelection(data)
                          }}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        allowDataExport={false}
                        gridData={unSyncedJEList}
                        onSearch={onSearch}
                        onColumnAdd={newColumnAdded}
                        onFilter={onFilter}
                        gridWidth={gridWidth}
                        filter={unSyncedJEList.filter}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            const config = {
                                ...BooksIntegrationService.apiConfig,
                                page: requestedPageNumber - 1
                            };
                            loadPayruns(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={isActionEnabled}
                        isHeaderHidden={true}
                        onRowOpenBtnHidden={true}
                    />
                </div>
            </div>
        </>
    )
}
export default SyncJEToBooksTable